module.exports = __webpack_public_path__ + "img/header3.636a4cfc.jpg";